import { ReactNode } from "react";

export type MultiSelectCheckboxesMenuData = {
  disabled?: boolean;
  label: ReactNode;
  value: string;
  title?: string;
};

export type MultiSelectCheckboxesMenuItem =
  | MultiSelectCheckboxesMenuData
  | JSX.Element;

export interface MultiSelectFormItem {
  label: string;
  value: string;
}

export type SelectedFields = Record<string, boolean>;

export type MultiSelectCheckboxesValues =
  | SelectedFields
  | Record<PropertyKey, never>
  | undefined;
